/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { UserCreateCourseRefId } from './userCreateCourseRefId';
import type { UserCreateCourseRefExternalProductId } from './userCreateCourseRefExternalProductId';
import type { UserCreateCourseRefExtraModuleIds } from './userCreateCourseRefExtraModuleIds';

/**
 * Course enrollment reference on user create (id and/or CRM product id + extras).
 */
export interface UserCreateCourseRef {
  id?: UserCreateCourseRefId;
  externalProductId?: UserCreateCourseRefExternalProductId;
  extraModuleIds?: UserCreateCourseRefExtraModuleIds;
}
